import React, { useContext, useEffect, useState } from "react";
import "./Wishlist.css";
import { Star } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import { getProducts } from "../../util/ApiService";
import ProductCard from "../widget/ProductCard";

export const mockWishlistItems = [
  {
    id: 1,
    name: "Gucci duffle bag",
    price: 960,
    originalPrice: 1160,
    image: "/path-to-image/gucci-bag.jpg",
    discount: "-20%",
  },
  {
    id: 2,
    name: "RGB liquid CPU Cooler",
    price: 1860,
    image: "/path-to-image/cpu-cooler.jpg",
  },
  {
    id: 3,
    name: "GP11 Shooter USB Gamepad",
    price: 550,
    image: "/path-to-image/gamepad.jpg",
  },
  {
    id: 4,
    name: "Quilted Satin Jacket",
    price: 750,
    image: "/path-to-image/jacket.jpg",
  },
];

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const { currentLang } = useContext(LanguageContext);

  useEffect(() => {
    getProducts({
      offset: 0,
      pagesize: 4,
      languageCode: currentLang,
    })
      .then((response) => {
        setProducts(response.data.content);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const user = localStorage.getItem("users");

    if (!user) {
      console.warn("User not logged in.");
      return;
    }
    const storedWishlist = localStorage.getItem("wishlist");
    if (storedWishlist) {
      setWishlistItems(JSON.parse(storedWishlist));
    }
  }, []);

  const handleRemoveFromWishlist = (itemId) => {
    const updatedWishlist = wishlistItems.filter((item) => item.id !== itemId);
    setWishlistItems(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
  };

  const handleAddToCart = (itemId) => {
    navigate(`/product/${itemId}`);
  };

  const renderRatingStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        size={16}
        className={index < rating ? "star-filled" : "star-empty"}
      />
    ));
  };

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <div className="wishlist-container">
      {wishlistItems.length > 0 && (
        <>
          <div className="wishlist-header">
            <h2>Wishlist</h2>
          </div>
          <div className="products-grid">
            {wishlistItems.map((item) => (
              <div className="product-card" key={item.id}>
                <div className="product-image">
                  {item.discount && (
                    <span className="discount">{item.discount}</span>
                  )}
                  <button
                    className="remove-button"
                    onClick={() => handleRemoveFromWishlist(item.id)}
                  >
                    <span className="remove-icon">×</span>
                  </button>
                  <img src={item.images?.[0]} alt={item.name} />
                  <button
                    className="add-to-cart"
                    onClick={() => handleAddToCart(item.id)}
                  >
                    Add To Cart
                  </button>
                </div>
                <div className="product-info">
                  <h3>{item.name}</h3>
                  <div className="price-info">
                    <span className="current-price">${item.sellingPrice}</span>
                    {item.originalPrice && (
                      <span className="original-price">
                        ${item.originalPrice}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {wishlistItems.length === 0 && (
        <div className="empty-wishlist-container">
          <div className="heart-icon">♡</div>
          <h2 className="empty-title">Your Wishlist is Empty</h2>
          <p className="empty-description">
            Looks like you haven’t added anything yet.
          </p>
          <Link to="/" className="browse-button">
            Browse Products
          </Link>
        </div>
      )}

      {/* Recommended Products Section */}

      <div className="recommended-section">
        <div className="section-header">
          <h2>Just For You</h2>
          <button className="see-all" onClick={handleNavigate}>
            See All
          </button>
        </div>

        <div className="product-list">
          {products?.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Wishlist;
